var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button"},[_c('div',{staticClass:"wrapper"},[(_vm.ready)?_c('img',{class:{ shake: _vm.shake },attrs:{"src":require("@/assets/03_Button.png")}}):_c('img',{staticClass:"disabled",attrs:{"src":require("@/assets/03_Button-4.png")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }